// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  AllBanksOutOfServiceResponse,
  AllBanksOutOfServiceResponseT,
  verifyAllBanksOutOfServiceResponse,
} from "./all-banks-out-of-service-response";

export class AllBanksOutOfServiceResponses implements flatbuffers.IUnpackableObject<AllBanksOutOfServiceResponsesT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): AllBanksOutOfServiceResponses {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsAllBanksOutOfServiceResponses(
    bb: flatbuffers.ByteBuffer,
    obj?: AllBanksOutOfServiceResponses,
  ): AllBanksOutOfServiceResponses {
    return (obj || new AllBanksOutOfServiceResponses()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsAllBanksOutOfServiceResponses(
    bb: flatbuffers.ByteBuffer,
    obj?: AllBanksOutOfServiceResponses,
  ): AllBanksOutOfServiceResponses {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new AllBanksOutOfServiceResponses()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  results(index: number, obj?: AllBanksOutOfServiceResponse): AllBanksOutOfServiceResponse | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new AllBanksOutOfServiceResponse()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  resultsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startAllBanksOutOfServiceResponses(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addResults(builder: flatbuffers.Builder, resultsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, resultsOffset, 0);
  }

  static createResultsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startResultsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endAllBanksOutOfServiceResponses(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // results
    return offset;
  }

  static createAllBanksOutOfServiceResponses(
    builder: flatbuffers.Builder,
    resultsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    AllBanksOutOfServiceResponses.startAllBanksOutOfServiceResponses(builder);
    AllBanksOutOfServiceResponses.addResults(builder, resultsOffset);
    return AllBanksOutOfServiceResponses.endAllBanksOutOfServiceResponses(builder);
  }

  unpack(): AllBanksOutOfServiceResponsesT {
    return new AllBanksOutOfServiceResponsesT(
      this.bb!.createObjList<AllBanksOutOfServiceResponse, AllBanksOutOfServiceResponseT>(
        this.results.bind(this),
        this.resultsLength(),
      ),
    );
  }

  unpackTo(_o: AllBanksOutOfServiceResponsesT): void {
    _o.results = this.bb!.createObjList<
      AllBanksOutOfServiceResponse,
      AllBanksOutOfServiceResponseT
    >(this.results.bind(this), this.resultsLength());
  }

  unpackFields(...fields: string[]): AllBanksOutOfServiceResponsesT {
    const t = new AllBanksOutOfServiceResponsesT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("results")) {
      t.results = this.bb!.createObjList<
        AllBanksOutOfServiceResponse,
        AllBanksOutOfServiceResponseT
      >(this.results.bind(this), this.resultsLength());
    }
    return t;
  }
}

export class AllBanksOutOfServiceResponsesT implements flatbuffers.IGeneratedObject {
  constructor(public results: AllBanksOutOfServiceResponseT[] = []) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.results === null || this.results === undefined) {
      throw new Error('Required field "results" is not set');
    }
    const results = AllBanksOutOfServiceResponses.createResultsVector(
      builder,
      builder.createObjectOffsetList(this.results),
    );

    return AllBanksOutOfServiceResponses.createAllBanksOutOfServiceResponses(builder, results);
  }

  clone(): AllBanksOutOfServiceResponsesT {
    const obj = new AllBanksOutOfServiceResponsesT();
    obj.results = this.results.map((e) => e.clone());
    return obj;
  }

  equals(other: AllBanksOutOfServiceResponsesT): boolean {
    if (this.results.length !== other.results.length) return false;
    for (let i = 0; i < this.results.length; i++) {
      const a = this.results[i];
      const b = other.results[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyAllBanksOutOfServiceResponses(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyAllBanksOutOfServiceResponse);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "results");
  } finally {
    verifier.popDepth();
  }
}
